"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { primaryCourseContent } from "@/data/static-content";
import { useUser } from "@clerk/nextjs";
import Link from "next/link";
export default function DynamicCTAButton() {
  const $ = _c(3);
  const {
    isLoaded,
    isSignedIn
  } = useUser();
  if (!isLoaded) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Button variant="secondary" className="w-36 cursor-default" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== isSignedIn) {
    t0 = <Button className="bg-landingPagePrimary text-darkGray hover:bg-landingPagePrimary hover:brightness-90" asChild={true}>{isSignedIn ? <Link href="/student/dashboard">Go to dashboard</Link> : <Link href={`/course/${primaryCourseContent.slug}`}>Start learning today</Link>}</Button>;
    $[1] = isSignedIn;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}

// Recycled

{
  /* <OAuthSignInDialog>
      <Button className="bg-landingPagePrimary text-darkGray hover:bg-landingPagePrimary hover:brightness-90">
        Start learning today
      </Button>
    </OAuthSignInDialog> */
}

// return <div className="h-10 w-36 rounded-xl bg-muted" />;

// 29 Apr 2025

// const router = useRouter();
// const signInUrl = useSignInRedirectURL();

// onClick={() => router.push(signInUrl)}